import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { WA_BLACK, WA_TRANSPARANT } from '@constants';

export const FORM_FIELD = {
  IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x240'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Write a title...',
    rules: [{ required: true, message: 'Title is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    placeholder: 'Write the text for the description...',
    rules: [{ required: true, message: 'Description is required' }],
  },
  INPUT_NAME: {
    name: 'inputName',
    label: 'Name input:',
    placeholder: 'Write the text for the name label...',
    rules: [{ required: true, message: 'Name input is required' }],
  },
  INPUT_EMAIL: {
    name: 'inputEmail',
    label: 'Email input:',
    placeholder: 'Write the text for the email label...',
    rules: [{ required: true, message: 'Email input is required' }],
  },
  BUTTON_TEXT: {
    name: 'buttonText',
    label: 'Button text:',
    placeholder: 'Write the text for the button...',
    rules: [{ required: true, message: 'Button text is required' }],
  },
  BUTTON_URL: {
    entityName: 'page',
    urlName: 'url',
    label: 'Button URL:',
    placeholder: 'Enter the URL or start typing a page name...',
    rules: [{ required: true, message: 'URL or page is required' }],
    serialize: utils.entityOrUrlFieldSerialize,
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK, WA_TRANSPARANT],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
};
